/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Redo_Restore_ButtonInputs */



/**
* | output |
* | --- |
* | "Redo restore" |
*
* @param {Assistant_Redo_Restore_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_redo_restore_button = /** @type {((inputs?: Assistant_Redo_Restore_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Redo_Restore_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire la restauration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellung wiederholen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rifare il ripristino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повторить восстановить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rehacer restaurar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重新恢复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("復元をやり直す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनः पुनर्स्थापना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Refazer restauração")
	return /** @type {LocalizedString} */ ("Redo restore")
});